var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendgrid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256.000405,0 L256.000405,170.666936 L170.666936,170.666936 L170.666936,255.996382 L0.00201096905,255.996382 L0.002,170.666 L0,170.666936 L0,85.3314569 L85.3334681,85.3314569 L85.3334681,0 L256.000405,0 Z",
    fill: "#9DD6E3"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3F72AB",
    points: "0.00201096905 255.996382 85.3354791 255.996382 85.3354791 170.662915 0.00201096905 170.662915"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00A9D1",
    points: "170.666936 170.666936 256.000405 170.666936 256.000405 85.3314569 170.666936 85.3314569"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00A9D1",
    points: "85.3334681 85.3334679 170.666936 85.3334679 170.666936 0 85.3334681 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2191C4",
    points: "85.3334681 170.664925 170.666936 170.664925 170.666936 85.3314569 85.3334681 85.3314569"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3F72AB",
    points: "170.666936 85.3334679 256.000405 85.3334679 256.000405 0 170.666936 0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendgrid);
export default __webpack_public_path__ + "static/media/sendgrid.607a024c677ead1b221835520b3ebded.svg";
export { ForwardRef as ReactComponent };